import { Location } from 'history';
import TrackerBackend from './TrackerBackend';

class MultiTrackerBackend implements TrackerBackend {
	private trackers: TrackerBackend[];

	constructor( trackers: TrackerBackend[] ) {
		this.trackers = trackers;
	}

	initialize() {
		this.eachTracker( tracker => tracker.initialize() );
	}

	setUserID( userId: number ) {
		this.eachTracker( tracker => tracker.setUserID( userId ) );
	}

	setSuperProperties( superProperties: Record<string, unknown> ) {
		this.eachTracker( tracker => tracker.setSuperProperties( superProperties ) );
	}
	setUserProperties( userProperties: Record<string, unknown> ) {
		this.eachTracker( tracker => tracker.setUserProperties( userProperties ) );
	}

	trackLocation( location: Location ) {
		this.eachTracker( tracker => tracker.trackLocation( location ) );
	}
	trackPanel( panelName: string ) {
		this.eachTracker( tracker => tracker.trackPanel( panelName ) );
	}
	trackEvent( args: { category: string, action: string, [key: string]: unknown } ) {
		this.eachTracker( tracker => tracker.trackEvent( args ) );
	}

	private eachTracker( callback: ( tracker: TrackerBackend ) => void ) {
		this.trackers.forEach( callback );
	}
}

export default MultiTrackerBackend;
